// extracted by mini-css-extract-plugin
module.exports = {"propertyContainer":"_3dyWYj","picture":"_2a1r1-","container":"LTBXsG"};